// extracted by mini-css-extract-plugin
module.exports = {"pageStructure":"PageContent_pageStructure__2078a","solid":"PageContent_solid__HgZCg","notSolid":"PageContent_notSolid__3f29_"};